/**
 * 반응형 크기 계산 (minmax CSS 함수 생성)
 * @param max - 최대값
 * @param min - 최소값 (선택)
 * @param middle - 중간값 (선택)
 * @returns minmax CSS 함수 문자열
 * @public
 */
export const minmax = (max: number, min?: number, middle?: number) => {
  const minNumber =
    max < 30
      ? max / 2
      : max < 60
      ? max * 0.6
      : max < 90
      ? max * 0.7
      : max * 0.8;
  return `max(${min || minNumber}px, min(${
    middle || minNumber / 10
  }vw, ${max}px))`;
};
